// localStorage setitem

export const _set_token_in_localStorage = (token) => {
  localStorage.setItem("token", token);
};
